"use client"

import React, { useState } from "react"
import Pagination from "./pagination"
import { TestimonialsDocument } from "../../../../../../prismicio-types"

type Props = {
  pageData: TestimonialsDocument
  // other properties...
}

function convertToEmbedUrl(url: string) {
  const urlObj = new URL(url);
  const videoId = urlObj.searchParams.get('v');
  return `https://www.youtube.com/embed/${videoId}`;
}

export default function VideosDisplaySection({ pageData }: Props) {
  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 6

  return (
    <section className="container flex flex-col gap-6">
      <Pagination
          totalItems={pageData.data.link_to_videos.length}
          itemsPerPage={itemsPerPage}
          onPageChange={setCurrentPage}
          currentPage={currentPage}
        />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-4">
        {pageData.data.link_to_videos
          .slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)
          .map((item) => (
            <div key={item.title}>
              <div className="card border shadow-md h-[400px] flex flex-col">
                <div className="video-container h-[300px] flex-grow">
                  <iframe
                    width={"100%"}
                    height={"100%"}
                    src={convertToEmbedUrl(
                      item.video_link.link_type === "Web" && 'url' in item.video_link ? item.video_link.url : ""
                    )}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
                <div className="text-container p-4">
                  <h2 className="text-xl font-bold">{item.title}</h2>
                  <p>{item.description}</p>
                </div>
              </div>
            </div>
          ))}
      </div>
      <Pagination
          totalItems={pageData.data.link_to_videos.length}
          itemsPerPage={itemsPerPage}
          onPageChange={setCurrentPage}
          currentPage={currentPage}
        />
    </section>
  )
}

